var map;
var activeSiteLayer;
var sitesLayer;
var landsLayer;
var markers = [];
var initialCenter = {lat: 50.427475, lng: 4.464801};
var initialZoom = 12;
var activeZoom = 16;
var activeSiteId;
// var svgs = [];


$(document).ready(function(){
	if ($('#map').length) {

		function initMap(){

      // Add center calculation method
      google.maps.Polygon.prototype.getApproximateCenter = function() {
          var boundsHeight = 0,
              boundsWidth = 0,
              centerPoint,
              heightIncr = 0,
              maxSearchLoops,
              maxSearchSteps = 10,
              n = 1,
              northWest,
              polygonBounds = this.getBoundingBox(),
              testPos,
              widthIncr = 0;

          // Get polygon Centroid
          centerPoint = polygonBounds.getCenter();

          if (google.maps.geometry.poly.containsLocation(centerPoint, this)) {
              // Nothing to do Centroid is in polygon use it as is
              return centerPoint;
          } else {
              maxSearchLoops = maxSearchSteps / 2;
              
              // Calculate NorthWest point so we can work out height of polygon NW->SE
              northWest = new google.maps.LatLng(polygonBounds.getNorthEast().lat(), polygonBounds.getSouthWest().lng());

              // Work out how tall and wide the bounds are and what our search increment will be
              boundsHeight = google.maps.geometry.spherical.computeDistanceBetween(northWest, polygonBounds.getSouthWest());
              heightIncr = boundsHeight / maxSearchSteps;
              boundsWidth = google.maps.geometry.spherical.computeDistanceBetween(northWest, polygonBounds.getNorthEast());
              widthIncr = boundsWidth / maxSearchSteps;

              // Expand out from Centroid and find a point within polygon at 0, 90, 180, 270 degrees
              for (; n <= maxSearchLoops; n++) {
                  // Test point North of Centroid
                  testPos = google.maps.geometry.spherical.computeOffset(centerPoint, (heightIncr * n), 0);
                  if (google.maps.geometry.poly.containsLocation(testPos, this)) {
                      break;
                  }

                  // Test point East of Centroid
                  testPos = google.maps.geometry.spherical.computeOffset(centerPoint, (widthIncr * n), 90);
                  if (google.maps.geometry.poly.containsLocation(testPos, this)) {
                      break;
                  }

                  // Test point South of Centroid
                  testPos = google.maps.geometry.spherical.computeOffset(centerPoint, (heightIncr * n), 180);
                  if (google.maps.geometry.poly.containsLocation(testPos, this)) {
                      break;
                  }

                  // Test point West of Centroid
                  testPos = google.maps.geometry.spherical.computeOffset(centerPoint, (widthIncr * n), 270);
                  if (google.maps.geometry.poly.containsLocation(testPos, this)) {
                      break;
                  }
              }

              return(testPos);
          }
      };

			// -- set map's style --
			var styledMapType = new google.maps.StyledMapType(mapsStyle,{name: 'Plan'});

		  // -- map's settings --
		  map = new google.maps.Map(document.getElementById('map'), {
		    center: initialCenter,
		    zoom: initialZoom,
	    	streetViewControl: false,
	    	// mapTypeControl: false,
	    	mapTypeControlOptions: {
	    	  mapTypeIds: ['pacStyle','satellite']
	    	}
		  });


		  // -- set map's style --
		  map.mapTypes.set('pacStyle', styledMapType);
		  map.setMapTypeId('pacStyle');


			// -- create layers --
			activeSiteLayer = new google.maps.Data();
			sitesLayer = new google.maps.Data();
			landsLayer = new google.maps.Data();
			

			// -- load data to layer --
      sitesLayer.loadGeoJson(window.location.origin + '/json/sites');     

			// -- add layers to map --
			activeSiteLayer.setMap(map);
			sitesLayer.setMap(map);
			landsLayer.setMap(map);


			// -- init layers's style --
			initLayerStyle(sitesLayer, landsLayer);


			// -- event : sitesLayer click --
			sitesLayer.addListener('click', function(event) {
				activeSiteId = event.feature.Fg['ID_Site'];
				var sitesBaseUrl = $('#map').attr('data-siteUrl');
				var siteName = event.feature.Fg.sites_nom;
        siteName = siteName.replace(/\s/g,'-').toLowerCase();
        siteName = siteName.replace('/','-').toLowerCase();
				var url = sitesBaseUrl + '/' + siteName;
				// -- load webpage (via map) --
				loadContent(url, map);
				// -- center on active lands --
				centerOnActive(activeSiteId, activeSiteLayer, map);
				// -- show active lands --
				showActiveLands(activeSiteId, landsLayer, map);
			});


			// -- event : sitesLayer mouseover --
			sitesLayer.addListener('mouseover', function(event) {
				var hoverSiteId = event.feature.Fg['ID_Site'];
				var popup = $('#popup__' + hoverSiteId);
				var scrollTopPos = $(document).scrollTop();
				var mapTopPos = $('#map').offset().top;
				var mapHeight = $('#map').outerHeight();
				var popupTopPos;
				// -- check popup position --
				if (event.domEvent.y - mapTopPos + scrollTopPos < mapHeight / 2 ){
					popup.addClass('off-top');
					popupTopPos = event.domEvent.y + scrollTopPos - (popup.height() * 0.5) + 15;
				} else {
					popupTopPos = event.domEvent.y + scrollTopPos - (popup.height() * 1.5) - 35;
				}
				// -- show popup --
				popup.css({
					top: popupTopPos,
					left: event.domEvent.x - popup.width()/2
				}).fadeIn();
			});

			// -- event : sitesLayer mouseout --
			sitesLayer.addListener('mouseout', function(event) {
				var feature = event.feature.Fg;
				var outSiteId = feature['ID_Site'];
				var $popup = $('#popup__' + outSiteId);
				// -- hide popup --
				$popup.fadeOut();					
			});


			// -- event : zoom changed --
			google.maps.event.addListener(map, 'zoom_changed', function() {
		    var zoom = map.getZoom();
		    for (i = 0; i < markers.length; i++) {
	        markers[i].setVisible(zoom >= activeZoom-1);
		    }
			});

      sitesLayer.setStyle(function(feature) {
        var fillColor = '#004995';
        var strokeColor = '#0C83BB';
        if (feature.getProperty('isActive')) {
          fillColor = '#aaa';
          strokeColor = '#888';
        }
        return /** @type {!google.maps.Data.StyleOptions} */({
          fillColor: fillColor,
          strokeColor: strokeColor,
          strokeOpacity: 1,
          strokeWeight: 1,
          fillOpacity: 0.31,
          visible: true
        });
      });



		}


		function initLayerStyle(sitesLayer, landsLayer){
			// -- sites --

			var sitesDataStyle = {
        strokeColor: '#004995',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#0C83BB',
        fillOpacity: 0.31,
      	visible: true
			};

			sitesLayer.setStyle(sitesDataStyle);

			// -- active site --
			var activeSitesDataStyle = {
        strokeColor: '#004995',
        strokeOpacity: 0,
        strokeWeight: 1,
        fillColor: '#0C83BB',
        fillOpacity: 0,
      	visible: true
			};
			activeSiteLayer.setStyle(activeSitesDataStyle);

			// -- lands --
    	landsLayer.setStyle(function(feature) {
    		var fillOpacity = 0.50;
        var fillColor = '#0C83BB';
        var fStrokeColor = '#fff';
    		if (feature.getProperty('ID_Usage') == 1) { // en concession
    			fillColor = '#444';
          fStrokeColor = '#a4a4a4';
    			fillOpacity = 0.20;
    		} else if (feature.getProperty('ID_Usage') == 2) { // dispo
    			fillColor = '#0065F2';
    			fillOpacity = 0.20;
    		} else if (feature.getProperty('ID_Usage') == 3) { // quai public
    			fillColor = '#0C317A';
    			fillOpacity = 0.80;
    		} else if (feature.getProperty('ID_Usage') == 4) { // dispo à terme
    			fillColor = '#fff';
    			fillOpacity = 0.30;
          // e2001a
    		}
    	  return ({
    	    fillColor: fillColor,
    	    fillOpacity: fillOpacity,
  	      strokeColor: fStrokeColor,
  	      strokeOpacity: 1,
  	      strokeWeight: 1,
  	      zIndex: 9,
  	    	visible: true
    	  });
    	});
		}


    function loadContent(url, map){
    	$.ajax({
    	  type: 'GET',
    	  url: url,
    	  dataType: 'html',
    	  success: function(response, statut){
    	    // -- update head --
    	    var newTitle = $(response).filter('title').text();
    	    document.title = newTitle;
    	    $('meta[property="og:title"]').attr('content', newTitle);
    	    $('meta[name="twitter:title"]').attr('content', newTitle);
    	    $('meta[property="og:url"]').attr('content', url);
    	    // -- update content --
    	    var newContent = $(response).find('main');
    	    $('main').replaceWith(newContent);
    	    // -- update history --
    	    if (url != window.location.href) {
    	    	window.history.pushState(url, '', url);
    	    }
    	    // -- scrollTop --
    	    $('html, body').animate({scrollTop:0},500);
          // -- reload slick --
          reloadSlickGallery($('.slider--gallery'), sliderGallerySettings);
    	  }, error: function(response, status){
          console.log(response);
        }
    	});
    }


		function setZoom(map){
			if ($('main').hasClass('sites details')) {
				map.setZoom(activeZoom);
			} else {
				map.setZoom(initialZoom);
			}
		}


		function getBounds(layer){
			var bounds = new google.maps.LatLngBounds();
  		layer.forEach(function(feature) {
  			if (feature.Fg) {
    			// -- get polygon/multipolygon bounds --
    			if (feature.getGeometry().getType() === 'Polygon'){
    				feature.getGeometry().getArray().forEach(function(path){
    					path.getArray().forEach(function(latLng){
    						bounds.extend(latLng);
    					});
    				});
    			} else if (feature.getGeometry().getType() === 'MultiPolygon'){
    				feature.getGeometry().getArray().forEach(function(multipolygon){
    					multipolygon.getArray().forEach(function(path){
    						path.getArray().forEach(function(latLng){
    							bounds.extend(latLng);
    						});
    					});
    				});
    			}
  			}
  		});
			return bounds;
		}

    
    function addMarkers(map,feature){
  		var bounds = new google.maps.LatLngBounds();
  		var landId = feature.Fg.ID_Terrain.toString();
  		// -- get polygon/multipolygon bounds --
  		if (feature.getGeometry().getType() === 'Polygon'){
  			feature.getGeometry().getArray().forEach(function(path){
  				path.getArray().forEach(function(latLng){
  					bounds.extend(latLng);
  				});
  			});
  		} else if (feature.getGeometry().getType() === 'MultiPolygon'){
  			feature.getGeometry().getArray().forEach(function(multipolygon){
  				multipolygon.getArray().forEach(function(path){
  					path.getArray().forEach(function(latLng){
  						bounds.extend(latLng);
  					});
  				});
  			});
  		}
  		// -- Add lands markers --
  		var marker = new google.maps.Marker({
  	    position: bounds.getCenter(),
  	    label: {
  	      text: landId,
  	      color: '#004995',
  	      fontFamily: 'Arial',
  	      fontSize: '11px',
  	      fontWeight: '400'
  	    },
  	    icon: {
  	      path: google.maps.SymbolPath.CIRCLE,
  	      fillColor: 'white',
  	      fillOpacity: 1,
  	      strokeColor: '#004995',
  	      strokeWeight: 1,
  	      strokeOpacity: 1,
  	      scale: 12,
  	    }
  		});
  		marker.setMap(map);
  		markers.push(marker);
    }


    function removeMarkers(){
			for(i=0; i<markers.length; i++){
				markers[i].setMap(null);
			}
    }


    function removePattern(){
      $('.striped-polygon').remove();
    }


    function resetLayer(layer){
    	// -- reset layer --
			if (layer.Eg.Eg) {
				layer.forEach(function(feature) {
					layer.remove(feature);
				});
			}
    	// -- reset pattern --
      removePattern();
      // -- reset markers --
    	removeMarkers();
    }


    function resetIsActive(layer){
      layer.forEach(function(feature) {
        feature.setProperty('isActive', false);
      });
    }


    function centerOnActive(activeSiteId, activeSiteLayer, map){
    	// -- reset layer --
    	resetLayer(activeSiteLayer);
    	// -- load active data --
    	activeSiteLayer.loadGeoJson(window.location.origin + '/json/sites/'+activeSiteId, null, function (features) {
          // -- highlight active site --
          highlightActiveSite(sitesLayer);
    			// -- center map --
			    var activeSiteBounds = getBounds(activeSiteLayer);
    	    map.fitBounds(activeSiteBounds); 
    	    map.setCenter(activeSiteBounds.getCenter());
    	});

    }


    function showActiveLands(activeSiteId, landsLayer, map){
    	// -- show legend --
    	$('.legend__wrapper').fadeIn();
    	// -- reset layer --
    	resetLayer(landsLayer);
    	// -- show active lands --
			landsLayer.loadGeoJson(window.location.origin + '/json/lands/'+activeSiteId, null, function (features) {
        landsLayer.forEach(function(feature) {
          // -- add pattern --
          if (feature.getProperty('ID_Usage') == 4) { // dispo à terme
            var overlay = new BW.PolyLineFill(feature.getGeometry(), map, '#006AD8', '#006AD8', 'pattern1');
          }
          if (feature.getProperty('ID_Usage') == 2) { // dispo à terme
            var overlay = new BW.PolyLineFill(feature.getGeometry(), map, '#006AD8', '#006AD8', 'pattern2');
          }
          // -- add marker --
          if (feature.Fg) {
            addMarkers(map, feature);
          }
        });
			});
    }

    function highlightActiveSite(sitesLayer){
      sitesLayer.forEach(function(feature) {
        if ( feature.getProperty('ID_Site') == activeSiteId){
          feature.setProperty('isActive', true);
        console.log('isActive '+activeSiteId);
        } else {
          feature.setProperty('isActive', false);
        }
      });
    }


    function checkUrl(){
    	if ($('main').hasClass('sites details')) {
    		activeSiteId = $('main').attr('data-siteid');
    		centerOnActive(activeSiteId, activeSiteLayer, map);
    		showActiveLands(activeSiteId, landsLayer, map);
        setTimeout(function(){ highlightActiveSite(sitesLayer); }, 500);
        setTimeout(function(){ highlightActiveSite(sitesLayer); }, 1000);
    	}
    }

		// -- init map --
		initMap();

		// -- check url --
		checkUrl();

		// -- event : click link --
		$(document).on('click', '.sites__list a, .btn--back', function(event){
			event.preventDefault();
			var url = $(this).attr('href');
			// -- load webpage (via list) --
			loadContent(url, map);
			if (!$(this).hasClass('btn--back')) { // -- sites list --
				
				// -- show legend --
				$('.legend__wrapper').fadeIn();
				// -- center on active lands --
				activeSiteId = $(this).attr('data-siteid');
				centerOnActive(activeSiteId, activeSiteLayer, map);
				showActiveLands(activeSiteId, landsLayer, map);

			} else { // -- back btn --
				
				// -- hide legend --
				$('.legend__wrapper').fadeOut();
				// -- reset --
        resetLayer(activeSiteLayer);
				resetLayer(landsLayer);
        resetIsActive(sitesLayer);

				// -- reset map pos --
				map.setZoom(initialZoom);
				map.setCenter(initialCenter);

			}
		});


		// -- event : back in history --
	  $(window).bind('popstate', function(){
	 		var url = window.location.href;
			loadContent(url, map);
		});

	}
});